import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from 'auth/AuthProvider';

interface RoleBasedRouteProps {
    children: React.ReactElement;
    allowedRoles: ('teacher' | 'manager')[];
    redirectTo?: string;
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ 
    children, 
    allowedRoles,
    redirectTo 
}) => {
    const session = useSession();


    // Check if user has required role
    const hasAccess = allowedRoles.some(role => {
        if (role === 'manager') return session.role === 'manager';
        if (role === 'teacher') return session.role === 'teacher';
        return false;
    });

    if (!hasAccess) {
        // Default redirects based on user type
        const defaultRedirect = session.role === 'manager' ? '/organization-reports' : '/classes';
        return <Navigate to={redirectTo || defaultRedirect} replace />;
    }

    return children;
};

export default RoleBasedRoute;